import React from "react";
import styled from "styled-components";

import Modal from "../Modals/Modal";

const StyledBonusRecoveryModal = styled.div`
  padding: 28px;
  border-radius: 18px;
  color: #f4f8fc;
  background: var(--crypto-surface, #0b1d2d);

  .bonus-recovery-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    margin-bottom: 18px;
    border-radius: 13px;
    color: #071520;
    background: var(--crypto-blue, #58bff4);
    box-shadow: 0 10px 26px rgba(46, 166, 229, 0.22);
    font-size: 24px;
    font-weight: 900;
  }

  h2 {
    margin: 0;
    color: #ffffff;
    font-size: 22px;
    line-height: 1.3;
    font-weight: 900;
  }

  p {
    margin: 13px 0 0;
    color: #aebdcc;
    font-size: 15px;
    line-height: 1.65;
    word-break: keep-all;
  }

  .crypto-sports-bonus-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-top: 26px;
  }

  .crypto-sports-bonus-actions button {
    min-height: 46px;
    border: 0;
    border-radius: 11px;
    color: #c8d4df;
    background: rgba(255, 255, 255, 0.07);
    font-size: 14px;
    font-weight: 800;
    cursor: pointer;
  }

  .crypto-sports-bonus-actions button:hover {
    filter: brightness(1.08);
  }

  .crypto-sports-bonus-actions .is-primary {
    color: #06131d;
    background: var(--crypto-blue, #58bff4);
  }

  .crypto-sports-bonus-actions .is-only-action {
    grid-column: 1 / -1;
  }

  @media (max-width: 480px) {
    padding: 24px 20px 20px;

    h2 {
      font-size: 20px;
    }

    p {
      font-size: 14px;
    }
  }
`;

const MESSAGES = {
  slots: "슬롯 롤링 조건이 충족되지 않았습니다.",
  live: "라이브 롤링 조건이 충족되지 않았습니다.",
  sport: "스포츠 롤링 조건이 충족되지 않았습니다.",
  minigames: "미니게임 롤링 조건이 충족되지 않았습니다.",
  two_types: "보너스 롤링 조건이 충족되지 않았습니다.",
};

const BonusRecoveryModal = ({
  show,
  onHide,
  onConfirm,
  onCancel,
  bonusgames,
  actionType = "RECOVER",
}) => {
  const blocked = String(actionType || "").toUpperCase() === "BLOCK";
  const lead = MESSAGES[String(bonusgames || "").toLowerCase()] || MESSAGES.two_types;
  const message = blocked
    ? "보너스 롤링 조건이 충족되지 않아 현재 게임은 이용할 수 없습니다. 롤링 조건 충족 후 다시 이용해 주세요."
    : `${lead} 계속 진행하면 보너스 금액이 회수됩니다. 진행하시겠습니까?`;

  return (
    <Modal
      isOpen={Boolean(show)}
      onClose={onHide}
      maxWidth={420}
      zIndex={9000}
      dialogLabel={blocked ? "이용 제한" : "보너스 회수 안내"}
    >
      <StyledBonusRecoveryModal className="crypto-sports-bonus-modal">
        <span className="bonus-recovery-badge" aria-hidden="true">!</span>
        <h2>{blocked ? "이용 제한" : "보너스 회수 안내"}</h2>
        <p>{message}</p>
        <div className="crypto-sports-bonus-actions">
          {!blocked ? (
            <button type="button" onClick={onCancel || onHide}>취소</button>
          ) : null}
          <button
            type="button"
            className={`is-primary${blocked ? " is-only-action" : ""}`}
            onClick={() => {
              if (!blocked) onConfirm?.();
              onHide?.();
            }}
          >
            {blocked ? "닫기" : "확인"}
          </button>
        </div>
      </StyledBonusRecoveryModal>
    </Modal>
  );
};

export default BonusRecoveryModal;
